<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="106px"
    >
      <div class="title">
        添加奖励方案
      </div>
      <el-form-item label="方案名称" prop="planName">
        <el-input
          type="text"
          v-model.trim="ruleForm.planName"
          clearable
          maxlength="30"
          placeholder="请输入方案名称"
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="生效时间" prop="activityDate">
        <el-date-picker
          v-model="ruleForm.activityDate"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          align="right"
          start-placeholder="任务开始时间"
          end-placeholder="任务结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="参与门店" prop="targetShopIdList">
        <el-select
          size="small"
          clearable
          class="mr10"
          multiple
          @change="getCheckedStore"
          placeholder="请选择门店"
          v-model="ruleForm.targetShopIdList"
          filterable
        >
          <el-option
            label="全部门店"
            :disabled="selectOther"
            value="0"
          ></el-option>
          <el-option
            :label="item.name"
            :value="item.id"
            :disabled="selectAll"
            v-for="(item, i) in shopList"
            :key="i"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="奖励类型" prop="rewardType">
        <el-radio-group v-model="ruleForm.rewardType" size="small">
          <el-radio label="fixed">按数量固定奖励 </el-radio>
          <el-radio label="ratio">按金额百分比奖励</el-radio>
        </el-radio-group>
        <div>
          每销售一{{ ruleForm.rewardType === "fixed" ? "件" : "元" }}奖励
          <el-input
            type="text"
            v-model.trim="ruleForm.rewardValue"
            clearable
            maxlength="30"
            @input="filterGt0OrFixed2('rewardValue')"
            placeholder="请输入奖励"
            size="small"
          ></el-input
          >{{ ruleForm.rewardType === "fixed" ? "元" : "%" }}
        </div>
      </el-form-item>
      <div class="title">
        添加奖励商品
      </div>
      <el-form-item label="奖励商品" prop="rewardGoods">
        <div>
          <el-button class="mr10" type="primary" size="small" @click="addGoods"
            >添加商品</el-button
          >
        </div>
        <el-table
          stripe
          border
          ref="table"
          :data="rewardGoodList"
          style="width: 100%"
          id="table"
          size="small"
          v-if="goodsType === 'category'"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="关联类型"
          >
            <template slot-scope="scope">
              <div v-if="goodsType === 'category'">
                品类
              </div>
              <div v-if="goodsType === 'brand'">
                品牌
              </div>
              <div v-if="goodsType === 'goods'">
                商品
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="品类名称"
          >
            <template slot-scope="scope">
              {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuId"
            label="品类编码"
          >
            <template slot-scope="scope">
              {{ scope.row.spuId }}
            </template>
          </el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="remove(scope.$index)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          stripe
          border
          ref="table"
          :data="rewardGoodList"
          style="width: 100%"
          id="table"
          size="small"
          v-if="goodsType === 'brand'"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="关联类型"
          >
            <template>
              <div v-if="goodsType === 'category'">
                品类
              </div>
              <div v-if="goodsType === 'brand'">
                品牌
              </div>
              <div v-if="goodsType === 'goods'">
                商品
              </div>
            </template>
          </el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuId"
            label="品牌编码"
          >
            <template slot-scope="scope">
              {{ scope.row.spuId }}
            </template>
          </el-table-column>

          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="remove(scope.$index)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-table
          stripe
          border
          ref="table"
          :data="rewardGoodList"
          style="width: 100%"
          id="table"
          size="small"
          v-if="goodsType === 'goods'"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="关联类型"
          >
            <template slot-scope="scope">
              <div v-if="goodsType === 'category'">
                品类
              </div>
              <div v-if="goodsType === 'brand'">
                品牌
              </div>
              <div v-if="goodsType === 'goods'">
                商品
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryName"
            label="品类名称"
          >
            <template slot-scope="scope">
              {{ scope.row.categoryName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryId"
            label="品类编码"
          >
            <template slot-scope="scope">
              {{ scope.row.categoryId }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="品牌名称"
          >
            <template slot-scope="scope">
              {{ scope.row.brandName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandId"
            label="品牌编码"
          >
            <template slot-scope="scope">
              {{ scope.row.brandId }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="商品名称"
          >
            <template slot-scope="scope">
              {{ scope.row.spuName }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSnAndBarcode"
            label="商品编码"
          >
            <template slot-scope="scope">
              {{ scope.row.goodsSnAndBarcode }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="recommendedRetailPrice"
            label="商品价格"
          >
            <template slot-scope="scope">
              {{ scope.row.recommendedRetailPrice }}
            </template>
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button
                  size="small"
                  class="blue"
                  type="text"
                  @click="remove(scope.$index)"
                  >删除</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
    <div class="flex flex-center">
      <el-button type="primary" size="small" @click="submitForm('ruleForm')"
        >提交</el-button
      >
      <el-button size="small" @click="$router.back(-1)">返回</el-button>
    </div>
    <hm-transfer-shop-goods
      type="microShop"
      :visible="dialogVisible"
      @saveGoods="saveGoods"
      @close="dialogVisible = false"
    ></hm-transfer-shop-goods>
  </hm-content>
</template>

<script>
import HmTransferShopGoods from "@/components/HmTransferShopGoods";
export default {
  components: {
    HmTransferShopGoods
  },
  data() {
    const rewardTypeFunc = function(rule, val, callback) {
      if (val === "ratio") {
        if (this.ruleForm.rewardValue <= 0 || this.ruleForm.rewardValue > 100) {
          return callback(new Error("百分比奖励需大于0且小于100"));
        }
      } else {
        if (this.ruleForm.rewardValue <= 0) {
          return callback(new Error("奖励需大于0"));
        }
      }

      callback();
    }.bind(this);
    const rewardGoodsFunc = function(rule, val, callback) {
      if (this.rewardGoodList.length < 1) {
        return callback(new Error("请选择奖励商品"));
      }

      callback();
    }.bind(this);
    return {
      list: [],
      type: this.$route.query.type || false,
      planId: this.$route.query.planId || "",
      goodsType: "",
      selectOther: false,
      selectAll: false,
      dialogVisible: false,
      rewardGoodList: [],
      shopList: [],
      ruleForm: {
        planName: "",
        activityDate: [],
        targetShopIdList: [],
        rewardType: "fixed",
        rewardValue: ""
      },
      rules: {
        planName: {
          required: true,
          message: "请输入方案名称",
          trigger: "change"
        },
        activityDate: {
          required: true,
          message: "请选择生效时间",
          trigger: "change"
        },
        targetShopIdList: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        rewardType: [
          { required: true, message: "请选择奖励类型", trigger: "change" },
          { required: true, validator: rewardTypeFunc, trigger: "change" }
        ],
        rewardGoods: {
          required: true,
          validator: rewardGoodsFunc,
          trigger: "change"
        }
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryShopIdList();
    if (this.type) {
      this.queryDetails();
      this.queryList();
    }
  },
  methods: {
    async queryList() {
      let params = {
        pageNo: 1,
        pageSize: 9999,
        planId: this.planId
      };
      const { result } = await this.$store.dispatch(
        "detailRewardPlanBindingInfo",
        params
      );
      const { records } = result;
      this.list = records;
      this.goodsType = this.list[0].bindingType;
      this.list.forEach(v => {
        v.spuId = v.bindingCode;
        if (v.goodsType === "category") {
          v.name = v.categoryName;
        }
      });
      this.rewardGoodList = this.list;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("detailRewardPlan", {
        planId: this.planId
      });
      if (result.targetShopIds === "0") {
        result.targetShopIdList = ["0"];
      }
      result.activityDate = [result.startTime, result.endTime];
      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
    },
    async submitForm(ruleForm) {
      const valid = await this.$refs[ruleForm].validate();
      if (valid) {
        let params = this.ruleForm;
        params.startTime = params.activityDate[0];
        params.endTime = params.activityDate[1];

        params.bindingModelList = [];
        this.rewardGoodList.forEach(v => {
          params.bindingModelList.push({
            bindingType: this.goodsType,
            bindingCode: v.spuId
          });
        });
        if (this.type === "edit") {
          params.planId = this.planId;
        }
        let name = this.type === "edit" ? "editRewardPlan" : "addRewardPlan";

        const { code } = await this.$store.dispatch(name, params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.$router.back(-1);
        }
      }
    },
    remove(i) {
      this.rewardGoodList.splice(i, 1);
    },
    saveGoods(data) {
      if (data.rightData.length > 0) {
        if (this.goodsType === "") {
          this.goodsType = data.goodsType;
        } else {
          if (this.goodsType !== data.goodsType) {
            this.goodsType = data.goodsType;
            this.rewardGoodList = data.rightData;
          }
        }

        data.rightData.forEach(v => {
          let show = false;
          this.rewardGoodList.forEach(item => {
            if (item.spuId === v.spuId) {
              show = true;
            }
          });
          if (!show) {
            this.rewardGoodList.push(v);
          }
        });

        this.dialogVisible = false;
      } else {
        this.$message({
          message: "请选择商品",
          type: "warning"
        });
      }
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex(o => o !== "0") > -1;
      this.selectAll = storeList.findIndex(o => o === "0") > -1;
    },
    addGoods() {
      this.dialogVisible = true;
    },
    async queryShopIdList() {
      const { result } = await this.$store.dispatch("queryOnlineMallStoreList");

      this.shopList = result;
    },
    filterGt0OrFixed2(prop) {
      //   this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  color: rgba(34, 34, 34, 1);
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
